import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../constants';
import './ForgottenPasswordPage.css';

export function ForgottenPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const sendEmail = async (event: React.FormEvent) => {
    event.preventDefault();

    if (loading) {
      return;
    }

    const request = {
      email: email.trim(),
    };

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/forgotten-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        console.error('Passwort-E-Mail konnte nicht gesendet werden', response.status, response.statusText);
      }
    } catch (error) {
      console.error('Passwort-E-Mail konnte nicht gesendet werden', error);
    } finally {
      setLoading(false);
      navigate('/email-sent', { state: { email: request.email } });
    }
  };

  return (
    <main
      className="forgotten-password-page"
      style={{ '--forgotten-password-background-image': "url('/images/StartImage.jpg')" } as React.CSSProperties}
    >
      <section className="forgotten-password-page__card">
        <button
          type="button"
          onClick={() => navigate('/login')}
          className="forgotten-password-page__back"
          aria-label="Zurück zur Anmeldung"
        >
          <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" aria-hidden="true">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          Zurück zur Anmeldung
        </button>

        <div className="forgotten-password-page__header">
          <div className="forgotten-password-page__badge">
            <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.7" />
              <path d="m4 7 8 6 8-6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          <h1 className="forgotten-password-page__title">
            Passwort vergessen
          </h1>
          <p className="forgotten-password-page__description">
            Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
          </p>
        </div>

        <form className="forgotten-password-page__form" onSubmit={sendEmail}>
          <label htmlFor="forgotten-password-email" className="forgotten-password-page__label">
            E-Mail Adresse
          </label>
          <input
            id="forgotten-password-email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            className="forgotten-password-page__input"
          />

          <button
            type="submit"
            disabled={loading}
            className="forgotten-password-page__submit"
          >
            Passwort zurücksetzen
          </button>
        </form>

        <p className="forgotten-password-page__hint">
          Bitte prüfen Sie auch Ihren Spam-Ordner, falls Sie keine E-Mail erhalten.
        </p>
      </section>
    </main>
  );
}
